import { getLayer } from '@eventbrite/statsig';
import {
    UrgencySignalsProps,
    UrgencySignalsProvider,
} from '@eventbrite/urgency-signals';
import React, { useEffect, useState } from 'react';
import { LISTING_PAGE_GOING_FAST_EXPERIMENT } from '../../constants';
import { GoingFastExperimentVariantTypes } from './types';

interface Props {
    urgencySignals: UrgencySignalsProps;
}

export const UrgencySignalsProviderGoingFastExperiment: React.FC<Props> = ({
    children,
    urgencySignals,
}) => {
    const [experimentVariant, setExperimentVariant] = useState<
        | null
        | GoingFastExperimentVariantTypes.hidden
        | GoingFastExperimentVariantTypes.visible
    >(null);

    const hasGoingFastMessage = urgencySignals?.messages.goingFast;
    const isWaitingForExperimentVariant =
        hasGoingFastMessage && !experimentVariant;

    useEffect(() => {
        if (hasGoingFastMessage) {
            setExperimentVariant(
                getLayer(
                    LISTING_PAGE_GOING_FAST_EXPERIMENT.layer,
                    LISTING_PAGE_GOING_FAST_EXPERIMENT.param,
                    LISTING_PAGE_GOING_FAST_EXPERIMENT.defaultValue,
                ),
            );
        }
    }, [urgencySignals, hasGoingFastMessage]);

    if (isWaitingForExperimentVariant) {
        return <>{children}</>;
    }

    return (
        <UrgencySignalsProvider
            urgencySignals={urgencySignals}
            goingFastExperiment={
                experimentVariant === GoingFastExperimentVariantTypes.visible &&
                true
            }
        >
            {children}
        </UrgencySignalsProvider>
    );
};
